<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="流水号">
                            <c-input name="record_number" placeholder="请输入流水号"></c-input>
                        </m-search-item>
                        <m-search-item label="会员手机号">
                            <c-input name="phone" placeholder="请输入会员手机号"></c-input>
                        </m-search-item>
                        <m-search-item label="会员昵称">
                            <c-input name="user_realname" placeholder="请输入会员昵称"></c-input>
                        </m-search-item>
                        <m-search-item label="交易类型">
                            <c-input name="trans_classify" placeholder="请输入交易类型"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_mall_deposit_record_export')"
                              prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!-- 变动金额 -->
                <template #money="{data}">
					<p :style="`color:${data.income_expenses == 1 ? '#00B277' : '#FF5555'}`">{{data.income_expenses == 1 ? '+' : '-'}}{{data.money}}</p>
                </template>
                <!-- 余额 -->
                <template #surplus_money="{data}">
                    {{data.surplus_money}}
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name:'m_mall_account_record',

    components: {
    },

    data() {
        return {
            // 视图业务类型（550103=会员账户记录，对应视图ID）
            workType: 550103,
            // 默认查询参数：user_type=3（平台会员）
            defaultSearchData: {
                user_type: 3,
				account_type: 3
            },
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),
    },

    methods: {
        // 权限检查方法
        auth(permission) {
            // 这里可以根据项目的权限系统实现
            // 现在返回 true 表示有权限，实际应该从用户权限列表中检查
            return true
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
